module.exports = __webpack_public_path__ + "static/ninja-b0609acfe292e4208bf0d1bd78193b3b.jpg";